import { useContext } from 'react';
import { StoreProducts } from '../components';
import { StoreContext } from '../contexts/store.context';
import { StoreProviderValue } from '../models';

export function MyEntriesPage() {
   const { userRaffleEntries, setUserRaffleEntries } = useContext<StoreProviderValue>(StoreContext);

   // return (
   //    <iframe
   //       src="https://g-mint-site.vercel.app/"
   //       className="w-100 h-100"
   //    />
   // );

   return (
      <StoreProducts
         raffles={userRaffleEntries}
         setRaffles={setUserRaffleEntries}
         origin="my-entries"
      />
   );
}
